import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { EnvironmentService } from 'src/services/environment/environment.service';
import { LocaleService } from 'src/services/locale/locale.service';

@Injectable({ providedIn: 'root' })
export class LocaleCookieService {
    private readonly platformId = inject(PLATFORM_ID);
    private readonly cookieService = inject(CookieService);
    private readonly localeService = inject(LocaleService);
    private readonly environmentService = inject(EnvironmentService);

    private readonly LOCALE_COOKIE_NAME = 'wrikeLocale';
    private readonly LOCALE_COOKIE_YEARS_BEFORE_EXPIRE = 100;

    public setLocaleCookie(newCookieValue?: string): void {
        if (isPlatformBrowser(this.platformId)) {
            if (newCookieValue) {
                this.deleteOldCookie(this.LOCALE_COOKIE_NAME, '');
                this.setCookie(this.LOCALE_COOKIE_NAME, newCookieValue);
            } else if (!this.cookieService.get(this.LOCALE_COOKIE_NAME)) {
                this.setCookie(this.LOCALE_COOKIE_NAME, this.localeService.getCurrentLocaleSlug());
            } else {
                const oldCookieValue = this.cookieService.get(this.LOCALE_COOKIE_NAME);
                this.deleteOldCookie(this.LOCALE_COOKIE_NAME, '');

                if (!this.cookieService.get(this.LOCALE_COOKIE_NAME)) {
                    this.setCookie(this.LOCALE_COOKIE_NAME, oldCookieValue);
                }
            }
        }
    }

    private deleteOldCookie(cookieName: string, domain: string): void {
        this.cookieService.set(cookieName, '', -1, '/', domain);
    }

    private setCookie(name: string, value: string): void {
        const date = new Date();
        const cookieDomain = this.environmentService.environment.cookieDomain;

        date.setFullYear(date.getFullYear() + this.LOCALE_COOKIE_YEARS_BEFORE_EXPIRE);

        this.cookieService.set(name, value, date, '/', cookieDomain);
    }
}
